import { ApiRouteService } from 'core/api';

const getBaseRoute = () =>
  `${ApiRouteService.getCompumedApiBaseRoute()}/api/integrations`;

export const IntegrationRouteService = {
  getBaseRoute,
};
